import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { wp } from "../api/WpApi";
import data from "./_setup.json";
import PageLoading from "./PageLoading";
import { Helmet } from "react-helmet";
import Breadcrumbs from "../helpers/Breadcrumbs";

const TagView = () => {
  const [tags, setTags] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  let navigate = useNavigate();

  useEffect(() => {
    setIsLoading(true);
    wp.tags()
      .perPage(100)
      .then((resp) => {
        setTags(resp || []);
        setIsLoading(false);
      })
      .catch((err) => {
        setError(err);
        setIsLoading(false);
      });
  }, []);

  if (error) return <div className="content">
    <Helmet>
      <meta name="robots" content="noindex"></meta>
    </Helmet>
    Error: {error.message}</div>;
  if (isLoading) return (
    <div className="container">
      <PageLoading />
    </div>
  );

  const breadcrumbsItems = [
    { name: "Home", url: "/" },
    { name: "All Recipes", url: `/${data.url.slug_posts}/` },
    { name: "Tags", url: `/${data.url.slug_posts}/${data.url.slug_tag}/` },
  ];

  // build simple CollectionPage JSON-LD
  const baseUrl = process.env.REACT_APP_PUBLIC_URL || window.location.origin;
  const tagsIndexUrl = `${baseUrl}/${data.url.slug_posts}/${data.url.slug_tag}/`;
  const schema = {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "CollectionPage",
        "@id": tagsIndexUrl,
        "url": tagsIndexUrl,
        "name": "Tags - Andrew's Cookin' Recipes",
        "isPartOf": { "@id": `${baseUrl}/#website` },
        "breadcrumb": { "@id": `${tagsIndexUrl}#breadcrumb` },
        "inLanguage": "en-US",
      },
    ],
  };

  return (
    <div className="content container">
      <br />
      <Helmet>
        <title>Tags | Andrew's Cookin'</title>
        <link rel="canonical" href={tagsIndexUrl} />
        <script type="application/ld+json">{JSON.stringify(schema)}</script>
      </Helmet>

      <div className="row">
        <div className="col">
          <button
            className="btn btn-outline-secondary"
            style={({ float: "left" }, { display: "flex" })}
            onClick={() => navigate(-1)}
          >
            Back
          </button>

          <h1 className="fw-bold">Tags from all the Recipes</h1>
          <small className="fw-light">Browse all the tags used on the site.</small>
          <Breadcrumbs items={breadcrumbsItems} />
        </div>
      </div>

      <hr />

      <div className="grid gap-2 grid-cols-1 md:grid-cols-3">
        {tags.map((t) => (
          <Link
            key={t.id}
            to={`/${data.url.slug_posts}/${data.url.slug_tag}/${encodeURIComponent(
              t.slug
            )}/`}
            className="tag-item btn btn-outline-secondary m-1"
          >
            {t.name} ({t.count})
          </Link>
        ))}
      </div>

      <hr />
    </div>
  );
};

export default TagView;
